module.exports = __webpack_public_path__ + "static/media/AlsaceBlue.cec2c80a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fabrics/AlsaceBlue.jpg
// module id = 25
// module chunks = 0